import styled from 'styled-components';
import { Card } from '../Card';
import { NamedContentEntryText } from '../ContentEntryText/NamedContentEntryText';
import errorCardImage from '../ScoreBreakdown/assets/ErrorCard.png';
import { SplitButton } from '../Button';
import {
  SteppingProgressBar,
  type SteppingProgressBarStep,
} from '../ProgressBar/SteppingProgressBar/SteppingProgressBar';
import { useCyberIQLevelsQuery } from '../../apiHooks/useCyberIQLevelsQuery';
import { useMemo } from 'react';

export const SecuritySnapshotErrorCard = () => {
  const { data: cyberIqLevelsData } = useCyberIQLevelsQuery();

  const stepperSteps: SteppingProgressBarStep[] = useMemo(
    () =>
      cyberIqLevelsData.map((level, index) => {
        return {
          value: index,
          label: level.id,
        };
      }),
    [cyberIqLevelsData],
  );

  return (
    <Card title={<NamedContentEntryText container={'span'} refKey="sectionTitles" subKey="scoreBreakdown" />}>
      <div style={{ position: 'relative' }}>
        <CardContainer>
          <Row>
            <img width={128} height={128} src={errorCardImage} alt="Error" />
            <Text>
              <HeadingText>
                <NamedContentEntryText refKey={'scoreBreakdownErrorCard'} container={'span'} subKey={'heading'} />
              </HeadingText>
              <DescriptionText>
                <NamedContentEntryText refKey={'scoreBreakdownErrorCard'} container={'span'} subKey={'description'} />
              </DescriptionText>
            </Text>
            <LevelContainer>
              <SplitButton
                leftElement={<NamedContentEntryText container={'span'} refKey="leaderboard" subKey="level" />}
                color="#B6BEDC"
                rightElement={
                  <LevelName>
                    <NamedContentEntryText
                      container={'span'}
                      refKey="securitySnapshotLevelsUnknown"
                      subKey="levelName"
                    />
                  </LevelName>
                }
              />
            </LevelContainer>
          </Row>
          <Row>
            <ProgressContainer>
              <SteppingProgressBar steps={stepperSteps} value={0} />
            </ProgressContainer>
          </Row>
        </CardContainer>
      </div>
    </Card>
  );
};

const CardContainer = styled(Card)`
  background-color: ${({ theme }) => theme.colors.pageBackground};
  box-shadow: unset;
  pointer-events: none;
`;

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 16px;
  margin-top: auto;
`;

const HeadingText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.heading};
  font-weight: 600;
`;

const DescriptionText = styled.span`
  font-size: ${({ theme }) => theme.fontSizes.normal};
  color: ${({ theme }) => theme.colors.normal};
  font-weight: 400;
`;

const LevelName = styled.span`
  text-transform: uppercase;
`;

const LevelContainer = styled.div`
  margin-left: auto;
  margin-bottom: auto;
`;

const ProgressContainer = styled.div`
  width: 100%;
  margin-top: 16px;
  opacity: 0.5;
`;

const Row = styled.div`
  width: 100%;
  display: flex;
  gap: 24px;
`;
